export enum AppConstants {
  STORAGE_KEY_PREFIX = 'wolk-stock-app'
}
